// extracted by mini-css-extract-plugin
export default {"signUpButton":"-Wpbx"};